// extracted by mini-css-extract-plugin
export default {"patentChart":"BPatentAnalysis-module_patentChart_c3c50531"};